// Synthesized bird tweets — short, warm, and pleasant
let _ctx = null;
function getCtx() {
  if (!_ctx) {
    const AudioCtor = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtor) return null;
    _ctx = new AudioCtor();
  }
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
}

// Play a single chirp at the given time with given parameters
function chirp(ctx, t, startFreq, endFreq, duration, peakGain) {
  const osc = ctx.createOscillator();
  osc.type = "sine";
  osc.frequency.setValueAtTime(startFreq, t);
  osc.frequency.exponentialRampToValueAtTime(endFreq, t + duration * 0.55);
  osc.frequency.exponentialRampToValueAtTime(
    startFreq * 0.85,
    t + duration
  );

  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0, t);
  gain.gain.linearRampToValueAtTime(peakGain, t + 0.008);
  gain.gain.exponentialRampToValueAtTime(0.001, t + duration);

  const hp = ctx.createBiquadFilter();
  hp.type = "highpass";
  hp.frequency.value = 1200;

  // soft saturation via slight low-pass to remove harsh highs
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 7000;

  osc.connect(hp).connect(lp).connect(gain).connect(ctx.destination);
  osc.start(t);
  osc.stop(t + duration + 0.02);
}

export function playTweet() {
  const ctx = getCtx();
  if (!ctx) return;
  const now = ctx.currentTime + 0.02;
  const baseFreq = 1900 + Math.random() * 1500; // 1900-3400 Hz
  const noteCount = 1 + Math.floor(Math.random() * 3); // 1-3 chirps
  const peak = 0.04 + Math.random() * 0.025; // soft volume

  for (let i = 0; i < noteCount; i++) {
    const t = now + i * (0.07 + Math.random() * 0.05);
    const startFreq = baseFreq * (0.9 + Math.random() * 0.25);
    const endFreq = startFreq * (1.4 + Math.random() * 0.6);
    const duration = 0.08 + Math.random() * 0.07;
    chirp(ctx, t, startFreq, endFreq, duration, peak);

    // Sometimes add a quick second pitch above for richness
    if (Math.random() > 0.55) {
      chirp(
        ctx,
        t + 0.015,
        startFreq * 1.5,
        endFreq * 1.4,
        duration * 0.7,
        peak * 0.5
      );
    }
  }
}
